import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

export default function IconEdit({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M12.2367 5.3051L14.0045 3.53734L16.8329 6.36576L15.0652 8.13353L12.2367 5.3051ZM10.1154 5.3051L11.1761
      4.24444L13.2974 2.12312C13.6879 1.7326 14.3211 1.7326 14.7116 2.12312L18.2472 5.65866C18.6377 6.04918 18.6377
      6.68235 18.2472 7.07287L16.1258 9.19419L15.0652 10.2549L8.43761 16.8824C7.92378 17.3962 7.24091 17.7061 6.51585
      17.7545L2.90742 17.995C2.60557 18.0151 2.35514 17.7647 2.37527 17.4629L2.61583 13.8544C2.66416 13.1294 2.97403
      12.4465 3.48786 11.9327L10.1154 5.3051ZM14.0045 9.19419L7.37695 15.8218C7.12003 16.0787 6.7786 16.2336 6.41607
      16.2578L3.94797 16.4223L4.11251 13.9542C4.13667 13.5917 4.29161 13.2502 4.54852 12.9933L11.1761 6.36576L14.0045
      9.19419Z</Icon>
  );
}
